import React, { useContext, useEffect, useRef, useState } from 'react';
import StylesContext from '../context/StylesContext';
import api from '../api';
import { useNavigate, useParams } from 'react-router-dom';
import MainContainer from '../components/MainContainer';
import CategoriesCard from '../components/CategoriesCard';
import StyledContainer from '../components/StyledContainer';
import MenuIcon from '../components/MenuIcon';
import '../styles/CategoryList.css';
import MainLogoContainer from '../components/MainLogoContainer';
import StyledTitle from '../components/StyledTitle';
import TopText from '../components/TopText';
import useTextToSpeech from '../hooks/useTextToSpeech';
import audioBip from '../assets/audios/bip.mp3';
import categoriesProps from '../interfaces/CategoryProps';
import checkCategory from '../helpers/checkCategory';
import menuItemsProps from '../interfaces/MenuItemProps';
import { getItemName } from '../helpers/extractItemName';
import checkItemName from '../helpers/checkItemName';
import useSessionStorage from '../hooks/useSessionStorage';
import useChart from '../hooks/useChart';
import ItemsList from '../components/ItemsList';
import Footer from '../components/Footer';
import { listCategoryItems, handleDescription, handleOrder, handleItemOptions, handleInvalidCommand, handleInvalidItemCommand } from '../helpers/textToSpeechHelpers';
import useGoogleCloudAPI from '../hooks/useGoogleCloudApi';
import VocalInterfaceContext from '../context/VocalInterfaceContext';
import { useLanguage } from '../hooks/languageService';

const MenuTranslate = {
  title: {
    'pt-BR': 'CARDÁPIO',
    'en-US': 'MENU',
    'es-ES': 'MENÚ'
  },
  repeat: {
    'pt-BR': 'repita',
    'en-US': 'repeat',
    'es-ES': 'repetir'
  },
  notFound: {
    'pt-BR': 'Opção não encontrada.',
    'en-US': 'Option not found.',
    'es-ES': 'Opción no encontrada.'
  },
  mainMenu: {
    'pt-BR': 'menu principal',
    'en-US': 'main menu',
    'es-ES': 'menú principal'
  },
  orders: {
    'pt-BR': 'pedidos',
    'en-US': 'orders',
    'es-ES': 'pedidos'
  },
  add: {
    'pt-BR': 'adicionar',
    'en-US': 'add',
    'es-ES': 'agregar'
  },
  description: {
    'pt-BR': 'descrição',
    'en-US': 'description',
    'es-ES': 'descripción'
  },
  choose: {
    'pt-BR': "Você escolheu "
  }
  
}

const CategoriesListVocal = () => {
  const { styles, setStyles } = useContext(StylesContext);
  const { setIsChart, setIsVocalInterface } = useContext(VocalInterfaceContext);
  const [categories, setCategories] = useState<Array<categoriesProps>>();
  const [textToSpeechCategories, setTextToSpeechCategories] = useState<string>('');
  const [played, setPlayed] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [isDescribingItem, setIsDescribingItem] = useState(false);
  const [items, setItems] = useState<Array<menuItemsProps>>();
  const history = useNavigate();
  const categoryPlayedRef = useRef<boolean>(false);
  const currentItemsStringRef = useRef<string>();
  const currentCategoryRef = useRef<string>();
  const currentItemRef = useRef<menuItemsProps>();
  const audioRef = useRef<HTMLAudioElement>(null);
  const { sessionStorageHandler, getStylesFromSessionStorage } = useSessionStorage();
  const updateChartQuantity = useChart();
  const { startRecording, transcription, setTranscription } = useGoogleCloudAPI();
  const { textToSpeech } = useTextToSpeech(audioRef);
  const { menu } = useParams<{ menu: string }>();
  const { selectedLanguage } = useLanguage();
  const langId = selectedLanguage.split('-')[0];
  const langEndpoint = langId.includes('pt') ? '' : `-${langId}`;

  const handleClick = () => {
    setPlayed(false);
    categoryPlayedRef.current = false;
    textToSpeech(textToSpeechCategories);
  };

  const handleAudioEnd = () => {
    if (!played) {
      setPlayed(true);
      if (audioRef.current) {
        audioRef.current.src = audioBip;
        audioRef.current.play();
      };
      setTimeout(() => {
        startRecording();
      }, 300);
    };
  };

  const handleChart = (menuItemEL: menuItemsProps) => {
    sessionStorageHandler(menuItemEL);
    updateChartQuantity();
  };

  const getCategoryItems = async (categoryName: string) => {
    try {
      const { data } = await api.get(`menu_itens/category/?url_id=${menu}${langEndpoint}&category_name=${categoryName}`);
      console.log(data)
      setItems(data);
      const itemsNames = getItemName(data);
      currentItemsStringRef.current = itemsNames;
      return itemsNames;
    } catch (error: any) {
      console.error(error.message);
    };
  };

  const handleCategoryOptions = async () => {
    if (categories) {
      console.log(transcription)
      const isCategory = checkCategory(categories, transcription);
      if (isCategory) {
        categoryPlayedRef.current = true;
        currentCategoryRef.current = isCategory;
         textToSpeech(`${MenuTranslate.choose[selectedLanguage as keyof typeof MenuTranslate.choose]} ${isCategory}`, async () => {
            setShowItems(true);
            await getCategoryItems(isCategory);
            setPlayed(false);
            listCategoryItems(textToSpeech, currentCategoryRef.current, currentItemsStringRef.current, selectedLanguage);
         })
      } else {
        textToSpeech(MenuTranslate.notFound[selectedLanguage as keyof typeof MenuTranslate.notFound], () => {
          setTranscription('');
          setPlayed(false);
          textToSpeech(textToSpeechCategories);
        });
      };
    }
  };

  useEffect(() => {
    if (transcription !== '') {
      if (categories && !categoryPlayedRef.current) {
        handleCategoryOptions();
        return;
      };
      if (MenuTranslate.mainMenu[selectedLanguage as keyof typeof MenuTranslate.mainMenu].includes(transcription) && categoryPlayedRef.current) {
        setIsDescribingItem(false);
        setShowItems(false);
        setPlayed(false);
        categoryPlayedRef.current = false;
        textToSpeech(textToSpeechCategories);
        return;
      };
      if (MenuTranslate.repeat[selectedLanguage as keyof typeof MenuTranslate.repeat].includes(transcription)) {
        setIsDescribingItem(false);
        setPlayed(false);
        setTranscription('');
        // transcripion é setado para uma string vazia para caso o user repita o comando
        listCategoryItems(textToSpeech, currentCategoryRef.current, currentItemsStringRef.current, selectedLanguage);
        return;
      };
      if (MenuTranslate.description[selectedLanguage as keyof typeof MenuTranslate.description].includes(transcription)) {
        if (currentItemRef.current) {
          textToSpeech(`${currentItemRef.current.description}.`, () => {
            setPlayed(false);
            setTranscription('');
            handleDescription(textToSpeech, selectedLanguage);
          });
        };
        return;
      };
      if (MenuTranslate.orders[selectedLanguage as keyof typeof MenuTranslate.orders].includes(transcription)) {
        setTranscription('');
        setIsVocalInterface(false);
        setIsChart(true);
        return;
      };
      if (MenuTranslate.add[selectedLanguage as keyof typeof MenuTranslate.add].includes(transcription)) {
        if (currentItemRef.current) {
          handleChart(currentItemRef.current);
          setIsDescribingItem(false);
          setPlayed(false);
          handleOrder(textToSpeech, currentItemRef.current.item_name, selectedLanguage);
        };
        return;
      };
      if (items && categoryPlayedRef.current) {
        const itemEl = checkItemName(items, transcription);
        if (itemEl) {
          setTranscription('');
          setPlayed(true);
          currentItemRef.current = itemEl;
          textToSpeech(`${MenuTranslate.choose[selectedLanguage as keyof typeof MenuTranslate.choose]} ${itemEl.item_name}`, () => {
            setPlayed(false);
            setIsDescribingItem(true);
            handleItemOptions(textToSpeech, selectedLanguage);
          })
        } else if (isDescribingItem) {
          handleInvalidItemCommand(textToSpeech, setTranscription, setPlayed, selectedLanguage);
        } else if (!isDescribingItem) {
          handleInvalidCommand(textToSpeech, setTranscription, setPlayed, currentCategoryRef.current, currentItemsStringRef.current, selectedLanguage);
        };
        return;
      };
    }
  }, [transcription]);

  useEffect(() => {
    // texto falado quando o componente é renderizado
    if (textToSpeechCategories !== '') {
      setPlayed(false);
      categoryPlayedRef.current = false;
      textToSpeech(textToSpeechCategories);
    };
  }, [textToSpeechCategories]);

  useEffect(() => {
    const getStyles = async () => {
      try {
        const stylesSessionStorage = getStylesFromSessionStorage();
        if (stylesSessionStorage) {
          setStyles(stylesSessionStorage);
        } else {
          const { data } = await api.get(`menu_styles/${menu}`);
          setStyles(data);
        };
      } catch (error: any) {
        console.error(error.message);
      };
    };
    const getCategories = async () => {
      try {
        const { data } = await api.get(`categories/?url_id=${menu}${langEndpoint}`);
        setCategories(data);
      } catch (error: any) {
        console.error(error.message);
      }
    };
    const getTextToSpeech = async () => {
      try {
        const { data } = await api.get(`cardapios/${menu}${langEndpoint}`);
        setTextToSpeechCategories(data.categoriesTextToSpeech);
      } catch (error: any) {
        console.error(error.message);
      }
    };
    getStyles();
    getCategories();
    getTextToSpeech();
  }, [menu]);

  return (
    <>
      <StyledContainer className='logo_client_categories_wrapper' onClick={handleClick}>
        <TopText />
        <MainLogoContainer wrapperClass='logo_client_categories' />
      </StyledContainer>
      {!showItems ?
        (
          <>
            <StyledContainer className='container_title_icon'>
              <StyledContainer className='menu_icon_wrapper'>
                <MenuIcon color={styles.menuIconColor} />
              </StyledContainer>
              <StyledTitle
                className='title_categories_list'
                $textColor={styles.textColor}
              >
                {MenuTranslate.title[selectedLanguage as keyof typeof MenuTranslate.title]}
              </StyledTitle>
            </StyledContainer>
            <StyledContainer className='categories_card_container'>
              {
                categories?.map(categorieEl => (
                  <CategoriesCard
                    isButton={false}
                    key={categorieEl.category_name}
                    categorieElement={categorieEl.category_name}
                    categorieImage={categorieEl.category_image}
                  />
                ))
              }
            </StyledContainer>
          </>
        ) : (
          items?.length &&
          <>
            <StyledContainer className='categories_card_container'>
              {
                items.map(itemEl => (
                  <ItemsList item_name={itemEl.item_name} price={itemEl.price} key={itemEl.item_name} item_image={itemEl.image} />
                ))
              }
            </StyledContainer>

          </>
        )
      }
      <Footer $footerLogoColor={styles.footerColor} classCategories='footer-categories' />
      <audio ref={audioRef} onEnded={handleAudioEnd} />
    </>
  )
}

export default CategoriesListVocal;